<template>
  <div class="card">
    <div class="top">
      <div class="match-time">{{ time }}</div>
      <div class="match-title">{{ title }}</div>
      <div class="btns">
        <div class="btn-wrap">
          <button
            v-if="status > 0"
            class="guess-btn"
            :class="{
              disable: status == 8 || status == 9,
              fail: status == 6,
              guessing: status == 2,
              medal: guessing_result,
              medal1: guessing_result == 1,
              medal2: guessing_result == 2,
              medal3: guessing_result == 3,
              medal4: guessing_result == 4,
            }"
            :disabled="status != 1"
            @click="onBtnClick"
          >
            <template v-if="status == 1"> 竞猜 </template>
            <template v-if="status == 2">
              <div class="top-postion">已选择</div>
            </template>
            <template v-if="status == 5">
              <div class="top-postion">+{{score}}
              <img src="./../../../assets/gou.png" style="position:absolute;right: -2.5vw;top: -8vw;width:6vw;" alt=""></div>
            </template>
            <template v-if="status == 6">
              <div class="top-postion">未猜中</div>
            </template>
            <template v-if="status == 8"> 积分不足 </template>
            <template v-if="status == 9"> 已关闭 </template>
          </button>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="match-type">{{ matchType }}</div>
      <div class="match-info">{{ matchInfo }}</div>
    </div>
    <div class="actual-result" v-if="actual_result">
      <div
        class="actual-medal"
        :class="{
          m1: actual_result == 1,
          m2: actual_result == 2,
          m3: actual_result == 3,
          m4: actual_result == 4
        }"
      ></div>
    </div>
  </div>
</template>

<script>

export default {
  components: {},
  data() {
    return {};
  },
  props: {
    // 比赛时间
    time: [String, Number],
    // 比赛类型
    matchType: String,
    // 比赛名称
    title: String,
    // 对阵信息
    matchInfo: String,
    // 参与状态
    status: [String, Number],
    // 用户猜的奖牌
    guessing_result: [String, Number],
    // 实际比赛结果
    actual_result: [String, Number],
    score: [String, Number],
  },
  methods: {
    onBtnClick() {
      if (this.status == 1) {
        this.$emit("guess");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  //ffc900  a288d4 5285c7
  position: relative;
  border-radius: 5px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  box-shadow: 0 3px 12px 3px rgba(0, 0, 0, 0.1);

  &:nth-of-type(3n) .top {
    background: #ffc900;
  }

  &:nth-of-type(3n + 1) .top {
    background: #a288d4;
  }
  &:nth-of-type(3n + 2) .top {
    background: #5285c7;
  }

  .top {
    display: flex;
    background-color: chocolate;
    padding: 8px 16px 8px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    color: #fff;

    .match-time {
      flex: 0 0 30%;
      font-size: 15px;
      font-weight: bold;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .match-title {
      flex: 0 0 40%;
      font-size: 15px;
      font-weight: bold;
      text-align: center;
    }

    .btns {
      flex: 0 0 30%;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      position: relative;
      .btn-wrap {
        position: absolute;
        top: 0;
        right: 0;
        .guess-btn {
          position: relative;
          border: 3px solid #fff;
          width: 60px;
          height: 60px;
          border-radius: 50%;
          background-color: #ff3b64;
          padding: 0;
          font-size: 12px;
          color: #fff;

          &.disable {
            background: #cbcbcb;
          }
          &.guessing {
            background: #5285c7;
          }
          &.fail {
            background: #999999;
          }
          .top-postion {
            position: absolute;
            bottom: 8px;
            width: 100%;
            font-size: 10px;
            text-align: center;
            font-weight: bold;
          }
          &.medal {
            background-repeat: no-repeat;
            background-size: auto 60%;
            background-position: center top;
          }
          &.medal1 {
            background-image: url("./imgs/m-1.png");
          }
          &.medal2 {
            background-image: url("./imgs/m-2.png");
          }
          &.medal3 {
            background-image: url("./imgs/m-3.png");
          }
           &.medal4 {
               background-position: center 2px;
            background-size: 50% 50%;
            background-image: url("./imgs/m-4.png");
          }
        }
      }
    }
  }

  .bottom {
    display: flex;
    padding: 8px 16px;
    .match-type {
      flex: 0 0 25%;
      font-size: 13px;
      // font-weight: ;
      text-align: center;
      justify-content: center;
      align-items: center;
    }
    .match-info {
      flex: 0 0 50%;
      font-size: 13px;
      //   color: #aaa;
      //font-weight: bold;
      text-align: center;
    }
  }

  .actual-result {
    position: absolute;
    left: -2%;
    top: 15px;
    width: 33px;

    .actual-medal {
      width: 100%;
      padding-bottom: 134%;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      z-index: 10;
      transform: rotate(-15deg);
      &.m1 {
        background-image: url("./imgs/m-1.png");
      }
      &.m2 {
        background-image: url("./imgs/m-2.png");
      }
      &.m3 {
        background-image: url("./imgs/m-3.png");
      }
       &.m4{
         padding-bottom: 100%;
        background-image: url("./imgs/m-4.png");
      }
    }
    img {
      width: 100%;
    }
  }
}
</style>